<rask-page
  pageTitle="Systemadministration"
  noPadding>
  <rask-tabs parameterName="section" class="mb-0 h-100" aid="sections" [wrap]="true" layout="parent">
    <rask-tab label="feature toggle" routeId="feature"
      [canDeactivate]="feature.canDeactivate">
      <rask-sysadm-featuretoggle #feature></rask-sysadm-featuretoggle>
    </rask-tab>
    <rask-tab label="vacs" routeId="vacs"
      [canDeactivate]="vacs.canDeactivate">
      <rask-sysadm-vacs #vacs></rask-sysadm-vacs>
    </rask-tab>
    <rask-tab label="virkesköp" routeId="virkeskop">
      <rask-sysadm-virkeskop></rask-sysadm-virkeskop>
    </rask-tab>
    <rask-tab label="kundorder" routeId="kundorder"
      [canDeactivate]="kundorder.canDeactivate">
      <rask-sysadm-kundorder #kundorder></rask-sysadm-kundorder>
    </rask-tab>
    <rask-tab label="arbetsorder" routeId="arbetsorder"
      [canDeactivate]="arbetsorder.canDeactivate">
      <rask-sysadm-arbetsorder #arbetsorder></rask-sysadm-arbetsorder>
    </rask-tab>
    <rask-tab label="Geometri" routeId="geometri" #geometriTab
    >
      @if (geometriTab.visited) {
      <rask-sysadm-geometri #geometri ></rask-sysadm-geometri>
      }

    </rask-tab>
    <rask-tab label="Generell" routeId="genrell"
      [canDeactivate]="generell.canDeactivate">
      <rask-sysadm-misc #generell></rask-sysadm-misc>
    </rask-tab>
    <rask-tab label="prolog" routeId="prolog"
      [canDeactivate]="prolog.canDeactivate">
      <rask-sysadm-prolog #prolog></rask-sysadm-prolog>
    </rask-tab>
    <rask-tab label="SKS-Anmälan" routeId="avverkningsanmalan"
      [canDeactivate]="avverkningsanmalan.canDeactivate">
      <rask-sysadm-avverkningsanmalan #avverkningsanmalan></rask-sysadm-avverkningsanmalan>
    </rask-tab>
    <rask-tab label="Viol3" routeId="viol3">
        <rask-sysadm-viol3></rask-sysadm-viol3>
    </rask-tab>
    <rask-tab label="Virkesleverantörer" routeId="virkesleverantorer">
      <rask-sysadm-virkesleverantorer></rask-sysadm-virkesleverantorer>
    </rask-tab>
    <rask-tab label="Verksamhetsområden" routeId="verksamhetsomraden">
      <rask-sysadm-verksamhetsomraden></rask-sysadm-verksamhetsomraden>
    </rask-tab>
    <rask-tab label="Webinstallningar" routeId="webinstallningar">
      <rask-sysadm-webinstallningar></rask-sysadm-webinstallningar>
    </rask-tab>
    <rask-tab label="EUDR" routeId="eudr">
      <rask-sysadm-eudr></rask-sysadm-eudr>
    </rask-tab>
    <rask-tab label="Checklista" routeId="checklista">
      <rask-sysadm-checklista></rask-sysadm-checklista>
    </rask-tab>
  </rask-tabs>
</rask-page>
